import { add, parseISO, startOfDay } from "date-fns";
import { RelativeDateConstraint } from "../../../types/Survey";

export default function getDateFromConstraint(dateConstraint: string | RelativeDateConstraint | undefined): Date | undefined {
    let result: Date | undefined = undefined;
    if (!dateConstraint) return result;
    if (typeof dateConstraint === 'string' || dateConstraint instanceof String) {
        result = parseISO(dateConstraint as string);
    } else {
        result = dateFromRelativeDateConstraint(dateConstraint as RelativeDateConstraint);
    }
    return result;
}

function relativeDateIsValid(relativeDate: RelativeDateConstraint): boolean {
    return (relativeDate && relativeDate.type === "RelativeDate");
}

function dateFromRelativeDateConstraint(relativeDate: RelativeDateConstraint): Date | undefined {
    if (relativeDateIsValid(relativeDate)) {
        let result = (relativeDate.fromStartOfDay == true || relativeDate.fromStartOfDay == "true") ? startOfDay(new Date()) : new Date();
        result = add(result, {
            years: relativeDate.offsetYears,
            months: relativeDate.offsetMonths,
            weeks: relativeDate.offsetWeeks,
            days: relativeDate.offsetDays,
            hours: relativeDate.offsetHours,
            minutes: relativeDate.offsetMinutes
        });
        return result;
    }
}